import { Link } from 'react-router-dom';

export default function FinalCtaSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden mb-10 md:mb-14">
            <img
              src="https://readdy.ai/api/search-image?query=Artfully%20arranged%20lifestyle%20product%20assortment%20including%20woven%20leather%20accessories%20natural%20fiber%20textiles%20handcrafted%20ceramic%20objects%20and%20minimalist%20stationery%20on%20warm%20sand%20toned%20organic%20cotton%20backdrop%20soft%20golden%20hour%20window%20light%20creating%20gentle%20gradient%20shadows%20editorial%20still%20life%20modern%20organic%20home%20aesthetic%20refined%20understated%20elegance&width=1200&height=600&seq=final-cta-img-v2-xf51&orientation=landscape"
              alt="Complete Pandabuy Spreadsheet collection overview"
              title="Explore the Complete Pandabuy Spreadsheet Today"
              className="w-full object-cover object-top"
            />
          </div>

          <div className="text-center">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight max-w-2xl mx-auto">
              Explore the complete
              <span className="italic font-light text-foreground-400"> Pandabuy Spreadsheet </span>
              and discover the latest finds today.
            </h2>
            <p className="mt-5 text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
              Thousands of verified products, trusted sellers, and daily updates — all in one place. Start browsing now and find your next favorite item.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 text-sm md:text-base font-semibold rounded-full bg-foreground-900 text-white hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-2"
              >
                Browse Full Spreadsheet
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
              <Link
                to="/article/pandabuy-spreadsheet-guide"
                className="px-8 py-3.5 text-sm md:text-base font-medium rounded-full border border-foreground-300 text-foreground-800 hover:bg-foreground-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Buying Guide
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}